import { useCallback, useState } from 'react'

export const useHandleShowAddNewDialog = () => {
  const [showAddNewDialog, setShowAddNewDialog] = useState(false)

  const handleShowNewDialog = useCallback(() => {
    setShowAddNewDialog(true)
  }, [])

  const handleCloseNewDialog = useCallback(() => {
    setShowAddNewDialog(false)
  }, [])

  return {
    showAddNewDialog,
    handleShowNewDialog,
    handleCloseNewDialog,
  }
}
